export const toggle = () => {
  return {
    type: 'torch:toggle',
    data: {}
  }
}
